/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Custom_EmptyInputs */

const en_admin_settings_custom_empty = /** @type {(inputs: Admin_Settings_Custom_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No custom configs yet. Click "Add" to create one.`)
};

/**
* | output |
* | --- |
* | "No custom configs yet. Click \"Add\" to create one." |
*
* @param {Admin_Settings_Custom_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_custom_empty = /** @type {((inputs?: Admin_Settings_Custom_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Custom_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_custom_empty(inputs)
});
export { admin_settings_custom_empty as "admin.settings.custom.empty" }